import KunLoading20 from './src/index'

KunLoading20.install = function (Vue) {
	Vue.component(KunLoading20.name, KunLoading20);
}

export default KunLoading20;
